import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Chatbot from './Chatbot';
import {
  LayoutDashboard, Users, UserCheck, Package, Tag, Truck, Wrench, Fuel,
  FileText, CreditCard, Receipt, BookOpen, TrendingUp, Route,
  BarChart3, Settings, LogOut, Menu, X, Landmark, Wallet, Building2
} from 'lucide-react';

const nav = [
  {
    section: 'Main', items: [
      { to: '/', label: 'Dashboard', icon: LayoutDashboard },
    ]
  },
  {
    section: 'Parties', items: [
      { to: '/ledgers', label: 'Ledgers', icon: Users },
    ]
  },
  {
    section: 'Inventory', items: [
      { to: '/categories', label: 'Categories', icon: Tag },
      { to: '/products', label: 'Products', icon: Package },
    ]
  },
  {
    section: 'Transactions', items: [
      { to: '/trade-entry', label: 'Add Sales/Purchase', icon: FileText },
      { to: '/trade', label: 'Sales & Purchases', icon: FileText },
      { to: '/payments', label: 'Payments', icon: CreditCard },
      { to: '/expenses', label: 'Expenses', icon: Receipt },
    ]
  },
  {
    section: 'Banking', items: [
      { to: '/banks', label: 'Banks & Cash', icon: Landmark },
      { to: '/bank-statements', label: 'Bank Statements', icon: Wallet },
    ]
  },
  {
    section: 'Fleet', items: [
      { to: '/vehicles', label: 'Vehicles', icon: Truck },
      { to: '/maintenance', label: 'Maintenance', icon: Wrench },
      { to: '/fuel', label: 'Fuel Log', icon: Fuel },
      { to: '/trips', label: 'Trips', icon: Route },
    ]
  },
  {
    section: 'Accounting', items: [
      { to: '/accounts', label: 'Chart of Accounts', icon: BookOpen },
      { to: '/journal', label: 'Journal', icon: TrendingUp },
    ]
  },
  {
    section: 'Reports', items: [
      { to: '/reports', label: 'Reports', icon: BarChart3 },
    ]
  },
  {
    section: 'Admin', items: [
      { to: '/company', label: 'Company', icon: Building2 },
      { to: '/users', label: 'Users', icon: Settings },
    ]
  },
];

const pageTitles = {
  '/': 'Dashboard',
  '/ledgers': 'Ledgers',
  '/products': 'Products & Inventory',
  '/categories': 'Product Categories',
  '/trade-entry': 'Add Sales / Purchase',
  '/trade': 'Sales & Purchases',
  '/payments': 'Payments & Receipts',
  '/expenses': 'Operational Expenses',
  '/banks': 'Banks & Cash Accounts',
  '/bank-statements': 'Bank Statements',
  '/vehicles': 'Vehicles',
  '/maintenance': 'Vehicle Maintenance',
  '/fuel': 'Fuel Log',
  '/trips': 'Trip Management',
  '/accounts': 'Chart of Accounts',
  '/journal': 'Journal Entries',
  '/reports': 'Financial Reports',
  '/users': 'User Management',
  '/company': 'Company Profile',
};

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const title = pageTitles[loc.pathname] || 'Traders ERP';

  return (
    <div className="layout">
      {open && <div className="sidebar-overlay" onClick={() => setOpen(false)}></div>}
      <aside className={'sidebar' + (open ? ' open' : '')}>
        <div className="sidebar-brand">
          <Truck size={22} />
          <div>
            <div>Traders ERP</div>
            <div className="sidebar-brand-sub">NORIS SOLUTIONS</div>
          </div>
        </div>
        {nav.map((s, i) => (
          <div key={i}>
            <div className="nav-section">{s.section}</div>
            {s.items.map(it => {
              const Ico = it.icon;
              return (
                <NavLink key={it.to} to={it.to} end={it.to === '/'} className="nav-item" onClick={() => setOpen(false)}>
                  <Ico size={16} />
                  <span>{it.label}</span>
                </NavLink>
              );
            })}
          </div>
        ))}
      </aside>

      <div className="main">
        <div className="topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0, flex: 1 }}>
            <button className="hamburger no-print" onClick={() => setOpen(!open)} aria-label="Menu">
              {open ? <X size={20} /> : <Menu size={20} />}
            </button>
            <h2 style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</h2>
          </div>
          <div className="topbar-right">
            <div className="user-chip">
              <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#1e40af', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, fontSize: 11, flexShrink: 0 }}>
                {user?.name?.[0]?.toUpperCase()}
              </div>
              <span className="user-name">{user?.name}</span>
              <span className="user-sep" style={{ color: '#94a3b8' }}>·</span>
              <span className="user-role" style={{ color: '#64748b', textTransform: 'capitalize' }}>{user?.role}</span>
            </div>
            <button className="btn-logout" onClick={logout}><LogOut size={13} style={{ verticalAlign: 'middle' }} /> <span className="logout-text">Logout</span></button>
          </div>
        </div>
        <div className="page">{children}</div>
      </div>
      <Chatbot />
    </div>
  );
}
